module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/Latest.0240fc3d.svg";